import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-92e6c8d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "video-page-container",
    "data-external": "video-page-container-element"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_VideoPlayer = _resolveComponent("VideoPlayer");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.page.loading)
            ? (_openBlock(), _createBlock(_component_VideoPlayer, {
                key: 0,
                url: _ctx.page.video && _ctx.page.video.videoUrl,
                "thumb-url": _ctx.thumbUrl,
                ratio: "16:9",
                onTimeupdate: _ctx.handleTimeUpdate,
                onPause: _ctx.handlePause,
                onEnded: _ctx.handleEnded
            }, null, 8, ["url", "thumb-url", "onTimeupdate", "onPause", "onEnded"]))
            : _createCommentVNode("", true)
    ]));
}
